<template>
  <div
    :class="{block: isBlock, error: isValidate === false, success: isValidate === true}"
    class="order-user-info-item">
    <div class="order-user-info-item_title">{{ item.name }}</div>
    <div
      v-if="isBlock"
      class="order-user-info-item_value">{{ getValue }}
    </div>
    <template v-else>
      <label
        :for="item.code"
        class="order-user-info-item_label">
        <input
          :value="getValue"
          :placeholder="item.placeholder"
          :id="item.code"
          class="order-user-info-item_input"
          @change="onChange">
        <div
          class="order-user-info-item_clear-wrapper"
          @click="clear">
          <svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M348.994 102.946L250.04 3.993c-5.323-5.323-13.954-5.324-19.277 0l-153.7 153.701 118.23 118.23 153.701-153.7c5.323-5.322 5.323-13.953 0-19.278zM52.646 182.11l-41.64 41.64c-5.324 5.322-5.324 13.953 0 19.275l98.954 98.957c5.323 5.322 13.954 5.32 19.277 0l41.639-41.641L52.646 182.11zM150.133 360h191.634v-28.051H182.806z"/></svg>
        </div>
      </label>
      <div class="order-user-info-item_validate-text">
        {{ getValidateText }}
      </div>
    </template>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import validation from '../../../utils/validation'

  export default {
    name: 'UserInfoBlock',
    props: {
      item: {
        type: Object,
        default: () => {
        }
      }
    },
    data: function () {
      return {
        isValidate: null
      }
    },
    methods: {
      ...mapMutations('order', [
        'setUserInfoValueById'
      ]),
      onChange: function (e) {
        this.changeValue(e.target.value)
      },
      changeValue: function (value) {
        this.setUserInfoValueById({
          id: this.item.id,
          value: value
        })
      },
      clear: function () {
        this.changeValue('')
        this.setUserInfoValueById({
          id: this.item.id,
          value: ''
        })
      }
    },
    computed: {
      ...mapGetters('order', [
        'getIsAuthorized',
        'getPersonalTypeSelected',
        'getSelectedProfile'
      ]),
      getValue: function () {
        let dataValid = this.item.validation
        this.isValidate = validation(dataValid.type)(this.item.value, dataValid.payload)
        return this.item.value
      },
      getValidateText: function () {
        if (this.isValidate === true) {
          return 'Верно'
        } else if (this.isValidate === false) {
          return 'Не верно'
        } else {
          return ''
        }
      },
      isBlock: function () {
        return this.getIsAuthorized &&
          this.getPersonalTypeSelected !== undefined &&
          this.getPersonalTypeSelected['id'] === 2 &&
          this.getSelectedProfile.id !== 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/UserInfo/UserInfoBlock.vue